import { Button, Card, Dropdown, ExternalLink, Text } from '@ui/themed';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import type { PriceListApiResponse } from '../../price-lists/types';
import { I18N_COMPONENTS } from '../constants';

export function AddPriceList({
  availableLists,
  onAdd,
}: {
  availableLists: PriceListApiResponse[];
  onAdd: (slug: string) => void;
}) {
  const [selected, setSelected] = useState<string>(availableLists[0]?.slug ?? '');

  useEffect(() => {
    if (!availableLists.some((list) => list.slug === selected)) {
      setSelected(availableLists[0]?.slug ?? '');
    }
  }, [availableLists, selected]);

  const hasLists = availableLists.length > 0;

  return (
    <Card>
      <Card.Body>
        <Dropdown
          label={t(`${I18N_COMPONENTS}.add_price_list.label`)}
          value={selected}
          onChange={setSelected}
          disabled={!hasLists}
          noOptionsMessage={t(`${I18N_COMPONENTS}.add_price_list.none_available`)}
          options={availableLists.map((list) => ({ value: list.slug, label: list.name }))}
        />
        <Button
          variant="secondary"
          disabled={!hasLists || !selected}
          onClick={() => onAdd(selected)}
        >
          {t(`${I18N_COMPONENTS}.add_price_list.button`)}
        </Button>
        <Text variant="secondary" size="sm">
          {t(`${I18N_COMPONENTS}.add_price_list.note`)}{' '}
          <ExternalLink link="/pricing/lists" showIcon>
            {t(`${I18N_COMPONENTS}.add_price_list.manage_link`)}
          </ExternalLink>
        </Text>
      </Card.Body>
    </Card>
  );
}
